import React, { useMemo, useState } from 'react';
import { useTable, useGlobalFilter } from 'react-table';
import { Card, Table, Row, CardHeader, Button } from 'reactstrap';
import { GlobalFilter } from 'components/Generic/GlobalFilter';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { columnsClient } from '../Route/table-city';
import { ClientSale } from './client-sale';
import { handleSendGeneric } from 'services/generic';
import { useEffect } from 'react';

const RowCustom = ({ provider, row, index }) => {
  const [open, setOpen] = useState(false);

  const updateStateOpen = (e) => {
    e.preventDefault();
    setOpen(!open);
  };
  return !open ? (
    <tr
      key={index}
      {...row.getRowProps()}
      {...provider.draggableProps}
      ref={provider.innerRef}
      onClick={updateStateOpen}
    >
      <td {...provider.dragHandleProps}> = </td>
      {row.cells.map((cell) => {
        return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
      })}
    </tr>
  ) : (
    <>
      <tr
        key={index}
        {...row.getRowProps()}
        {...provider.draggableProps}
        ref={provider.innerRef}
        onClick={updateStateOpen}
      >
        <td {...provider.dragHandleProps}> = </td>
        {row.cells.map((cell) => {
          return (
            <td {...cell.getCellProps()} style={{ fontSize: '18px' }}>
              {cell.render('Cell')}
            </td>
          );
        })}
      </tr>
      <tr>
        <td colSpan='100%'>
          <>
            <ClientSale
              disableGlobalFilter={true}
              columns={columnsClient}
              data={row.original.clients}
              city={row.original}
            />
          </>
        </td>
      </tr>
    </>
  );
};

export function TableGenericWithDragAndDrop({ columns, data, setData, route }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter
  );

  const { globalFilter } = state;

  const handleSavePosition = (dataView) => {
    handleSendGeneric(
      '/v1/data-view?type=ROUTE_CITY&action=UPDATE&idFather=' + route.id,
      'POST',
      dataView
    );
  };

  const handleDragEnd = async (e) => {
    const { source, destination } = e;
    if (!destination || source.index === destination.index) return;
    let dataRaw = [];

    setData((prevData) => {
      const tempData = [...prevData];
      const [removed] = tempData.splice(source.index, 1);
      tempData.splice(destination.index, 0, removed);
      dataRaw = [...tempData];
      return tempData;
    });

    await handleSavePosition(dataRaw);
  };

  return (
    <>
      <GlobalFilter
        disableButtomCreate={true}
        filter={globalFilter}
        setFilter={setGlobalFilter}
      />
      <DragDropContext onDragEnd={handleDragEnd}>
        <Table responsive hover {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                <th />
                {headerGroup.headers.map((column) => (
                  <th
                    scope='col'
                    {...column.getHeaderProps()}
                    style={{ fontSize: '18px' }}
                  >
                    {column.render('Header')}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <Droppable droppableId='droppable-1'>
            {(provider) => (
              <tbody
                {...getTableBodyProps()}
                ref={provider.innerRef}
                {...provider.droppableProps}
              >
                {rows.length !== 0 ? (
                  rows.map((row, index) => {
                    prepareRow(row);
                    return (
                      <Draggable
                        key={row?.original?.name}
                        draggableId={row?.original?.name}
                        index={index}
                      >
                        {(provider) => (
                          <RowCustom
                            provider={provider}
                            row={row}
                            index={index}
                          />
                        )}
                      </Draggable>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan='7'
                      style={{
                        textAlign: 'center',
                        width: '20px',
                        fontSize: '18px',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          gap: '14px',
                          alignItems: 'center',
                        }}
                      >
                        Não há cidades vinculadas as rotas, por gentileza
                        cadastre uma cidade!
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            )}
          </Droppable>
        </Table>
      </DragDropContext>
    </>
  );
}

export const CitySale = ({ data, route }) => {
  const [cities, setCities] = useState([]);

  const columns = useMemo(() => [...columnsClient], []);

  useEffect(() => {
    async function getData() {
      handleSendGeneric(
        '/v1/data-view?type=ROUTE_CITY&idFather=' + route.id,
        'POST',
        data
      ).then((response) => {
        setCities(() => {
          return response.data[0];
        });
      });
    }

    getData();
  }, [route.id, data, setCities]);

  const handleSavePosition = () => {
    handleSendGeneric(
      '/v1/data-view?type=ROUTE_CITY&idFather=' + route.id,
      'POST',
      cities
    ).then((response) => {
      setCities(() => {
        return response.data[0];
      });
    });
  };

  return (
    <>
      <Card className='shadow'>
        <CardHeader className='border-0'>
          <Row className='align-items-center'>
            <div
              style={{ display: 'flex', justifyContent: 'space-between' }}
              className='col'
            >
              <h3 className='mb-0'>Cidades</h3>
              <Button
                color='success'
                onClick={() => handleSavePosition()}
                size='md'
              >
                Ordernar
              </Button>
            </div>
          </Row>
        </CardHeader>
        <TableGenericWithDragAndDrop
          columns={columns}
          data={cities}
          setData={setCities}
          route={route}
        />
      </Card>
    </>
  );
};
